import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';

window.addEventListener('DOMContentLoaded', () => {
    const swiperElementOffer = document.querySelector('.offer-list .wp-block-query');
    let accumulatedRotation = 0;
    const anglePerSlide = 60;
    const sectionOfferWrapper = document.querySelector('.section-offer-wrapper');

    const iconHalves = [
        {
            before: `url(/wp-content/themes/lukla/assets/dist/svgs/Digital2.svg)`,
            after: `url("/wp-content/themes/lukla/assets/dist/svgs/Digital1.svg")`
        },
        {
            before: `url("/wp-content/themes/lukla/assets/dist/svgs/Cloud2.svg")`,
            after: `url("/wp-content/themes/lukla/assets/dist/svgs/Cloud1.svg")`
        },
        {
            before: `url("/wp-content/themes/lukla/assets/dist/svgs/WebMarketing2.svg")`,
            after: `url("/wp-content/themes/lukla/assets/dist/svgs/WebMarketing1.svg")`
        },
        {
            before: `url("/wp-content/themes/lukla/assets/dist/svgs/Change2.svg")`,
            after: `url("/wp-content/themes/lukla/assets/dist/svgs/Change1.svg")`
        },
        {
            before: `url("/wp-content/themes/lukla/assets/dist/svgs/Data2.svg")`,
            after: `url("/wp-content/themes/lukla/assets/dist/svgs/Data1.svg")`
        },
        {
            before: `url("/wp-content/themes/lukla/assets/dist/svgs/Manage2.svg")`,
            after: `url("/wp-content/themes/lukla/assets/dist/svgs/Manage1.svg")`
        }
    ]

    window.addEventListener('load', () => {
        if (window.innerWidth >= 970) {
            sectionOfferWrapper.style.background = `${iconHalves[0].before} left no-repeat, ${iconHalves[0].after} right no-repeat`;
            sectionOfferWrapper.style.backgroundSize = 'contain';
        } else {
            sectionOfferWrapper.style.background = '';
        }
    });

    window.addEventListener('resize', () => {
        if (window.innerWidth >= 970) {
            sectionOfferWrapper.style.background = `${iconHalves[activeIndex].before} left no-repeat, ${iconHalves[activeIndex].after} right no-repeat`;
            sectionOfferWrapper.style.backgroundSize = 'contain';
        } else {
            sectionOfferWrapper.style.background = '';
        }
    });

    function updateBeforeWrapper(activeIndex) {
        if (sectionOfferWrapper && iconHalves[activeIndex] && window.innerWidth >= 970) {
            sectionOfferWrapper.style.background = `${iconHalves[activeIndex].before} left no-repeat, ${iconHalves[activeIndex].after} right no-repeat`;
            sectionOfferWrapper.style.backgroundSize = 'contain';
        } else {
            sectionOfferWrapper.style.background = '';
        }
    }

    function initializeSwiper() {
        const swiper = new Swiper(swiperElementOffer, {
            modules: [Navigation],
            slidesPerView: 1,
            wrapperClass: 'wp-block-post-template',
            slideClass: 'wp-block-post',
            slideActiveClass: 'active',
            navigation: {
                prevEl: '.mobile-pagination-previous',
                nextEl: '.mobile-pagination-next',
            },
            loop: window.innerWidth < 970,
            breakpoints: {
                970: {
                    direction: 'vertical',
                    autoHeight: false,
                    height: 500,
                },
            },
            on: {
                slideChange: (swiper) => {
                    const activeIndex = swiper.realIndex;
                    const activeLiElement = 6 - activeIndex;
                    const wheelElement = document.querySelector('.offer-wheel > .wp-block-query > ul.wp-block-post-template');

                    updateBeforeWrapper(activeIndex);

                    const targetRotation = activeIndex * anglePerSlide;
                    let rotationDiff = targetRotation - (accumulatedRotation % 360);

                    if (rotationDiff > 180) {
                        rotationDiff -= 360;
                    } else if (rotationDiff < -180) {
                        rotationDiff += 360;
                    }

                    accumulatedRotation += rotationDiff;

                    if (wheelElement) {
                        wheelElement.style.transform = `rotate(${accumulatedRotation}deg)`;

                        wheelElement.classList.remove('active-index-0', 'active-index-1', 'active-index-2', 'active-index-3', 'active-index-4', 'active-index-5');
                        wheelElement.classList.add('active-index-'+activeIndex);

                        const liElements = wheelElement.querySelectorAll('li');
                        for (const [liElementIndex, liElement] of liElements.entries()) {
                            const iElement = liElement.querySelector('i');
                            if (iElement) {
                                iElement.style.transform = '';
                                iElement.style.transform = `rotate(${-accumulatedRotation}deg)`;

                                if (liElementIndex === (activeLiElement - 1)) {
                                    iElement.style.transform += ` scale(2)`;
                                }
                            }
                        }
                    }
                },
                navigationNext() {
                    clearInterval(intervalOfferWheel);
                },
                navigationPrev() {
                    clearInterval(intervalOfferWheel);
                },
                touchStart() {
                    clearInterval(intervalOfferWheel);
                }
            }
        });

        const intervalOfferWheel = setInterval(() => {
            if (window.innerWidth >= 970) {
                if (!swiper.isEnd) {
                    swiper.slideNext();
                } else {
                    swiper.slideTo(0);
                }
            } else {
                swiper.slideNext();
            }
        }, 5000);

        const listElements = document.querySelectorAll('.offer-list > .wp-block-query > ul.wp-block-post-template > li.wp-block-post');
        for (const [index, listElement] of listElements.entries()) {
            listElement.addEventListener('click', () => {
                swiper.slideToLoop(index);
                clearInterval(intervalOfferWheel);
            });
        }

        const wheelElements = document.querySelectorAll('.offer-wheel > .wp-block-query > ul.wp-block-post-template > li.wp-block-post');
        for (const [index, wheelElement] of wheelElements.entries()) {
            wheelElement.addEventListener('click', () => {
                swiper.slideToLoop(5 - index);
                clearInterval(intervalOfferWheel);
            });
        }

        handleResize();
    }

    function handleResize() {
        const activeIndex = swiper?.activeIndex || 0;
        updateBeforeWrapper(activeIndex);
    }

    window.addEventListener('resize', handleResize);

    if (swiperElementOffer) {
        initializeSwiper();
    }
});
